import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Alert, Snackbar } from "@mui/material";
export const AppContext = createContext();

export const useAppContext = () => {
  return useContext(AppContext);
};

const AppContextProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    msg: "",
    severity: "success",
  });
  const [loggedInUser, setLoggedInUser] = useState(null);

  const openSnack = useCallback((msg, severity, from) => {
    setSnackbar({
      open: true,
      msg,
      severity,
    });
  }, []);

  useEffect(() => {
    window.openSnack = openSnack;
  }, [openSnack]);

  return (
    <AppContext.Provider
      value={{ openSnack, snackbar, loggedInUser, setLoggedInUser }}
    >
      {children}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={10000}
        onClose={(e, reason) => {
          // eslint-disable-next-line no-unused-expressions
          reason === "clickaway"
            ? ""
            : setSnackbar({
                open: false,
                msg: "",
                severity: "success",
              });
        }}
        anchorOrigin={
          snackbar?.position || {
            vertical: "bottom",
            horizontal: "center",
          }
        }
      >
        <Alert
          severity={snackbar?.severity || "success"}
          variant="filled"
          onClose={(e, reason) =>
            reason === "backdropClick"
              ? ""
              : setSnackbar({
                  open: false,
                  msg: "",
                  severity: "success",
                })
          }
          sx={{
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "20px",
            color: `${snackbar?.severity === "success" && "#0F172A"} `,
          }}
        >
          {snackbar?.msg || ""}
        </Alert>
      </Snackbar>
    </AppContext.Provider>
  );
};

export default AppContextProvider;
